import { Breadcrumbs, Typography, Link, Stack, TablePagination } from "@mui/material";
import { Link as LinkTo } from "react-router";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { useCadastroPesquisaItensCadastroViewModel } from "../../viewModels/cadastro_pesquisa_itens_cadastro_view_model";
import { BackButton } from "../../../../../common/components/back_button";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { useMemo } from "react";
import { GenerateCadastroPesquisaItensCadastroColumnDefinition } from "./columns";
import { PesquisaSatisfacaoItemModal } from "./components/pesquisa_satisfacao_item_modal";
import { PesquisaSatisfacaoItemLista } from "../../../domain/models/pesquisa_satisfacao_item_lista";

import AlertError from "../../../../../common/components/alert_error";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import DeleteDialog from "../../../../../common/components/delete_dialog";

/**
 * CadastroPesquisaItensCadastro
 */

export const CadastroPesquisaItensCadastro = () => {
  const viewModel = useCadastroPesquisaItensCadastroViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateCadastroPesquisaItensCadastroColumnDefinition({
      onActionEditar: viewModel.handlePesquisaSatisfacaoItemOpenState,
      onActionDelete: viewModel.handlePesquisaSatisfacaoItemDelete,
    });
  }, [
    viewModel.handlePesquisaSatisfacaoItemOpenState,
    viewModel.handlePesquisaSatisfacaoItemDelete,
  ]);

  return (
    <>
      {/**
        * PageTopBar
        */}

      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[115px]">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onMouseDown={e => {
                    viewModel.handlePesquisaSatisfacaoItemOpenState(null, true);
                    e.preventDefault();
                  }}>
                  Novo Item
                </PrimaryButton>
              </div>

              <BackButton
                onClick={viewModel.handleBack}
              />
            </div>
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Entrega de Obras
          </Link>
          <Typography className="text-primary-green">
            <Link underline="hover" color="inherit" component={'span'}>
              <LinkTo to='/CadastroPesquisa_lista'>Cadastro de Pesquisa de Satisfação</LinkTo>
            </Link>
          </Typography>
          <Typography className="text-primary-green">
            Itens da Pesquisa de Satisfação
          </Typography>
        </Breadcrumbs>

        <div className="flex flex-col gap-0">
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-2xl font-medium text-black dark:text-white">
                Cadastro de Itens da Pesquisa de Satisfação
              </h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>

            <div className="w-full justify-start flex gap-2">

            </div>
          </div>
          <div className="w-full text-black dark:text-white font-bold">
            {
              viewModel.pesquisaSatisfacao !== null &&
              <h1>{viewModel.pesquisaSatisfacao.codigo} - {viewModel.pesquisaSatisfacao.descricao}</h1>
            }
          </div>
        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload} />
              </div>
            ) : (
              <>
                <Stack spacing={0}>
                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                  />

                  <StyledDataGrid
                    tableName="cadastro-pesquisa-itens-cadastro"
                    disableRowSelectionOnClick={true}
                    disableColumnMenu={false}
                    getRowId={(row: PesquisaSatisfacaoItemLista) => row.idItemPesquisaSatisfacao}
                    columns={columnsDefinition}
                    loading={viewModel.loading}
                    rows={viewModel.pesquisaSatisfacaoItens}
                    rowCount={viewModel.pesquisaSatisfacaoItens.length}
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.pagination.page,
                      pageSize: viewModel.pagination.rowsPerPage,
                    }}
                  />

                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                  />
                </Stack>
              </>
            )
        }
      </div>

      {/**
        * Modals
        */}

      <PesquisaSatisfacaoItemModal
        open={viewModel.itemPesquisaSatisfacaoModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedPesquisaSatisfacaoItem={viewModel.selectedPesquisaSatisfacaoItem}
        onClose={() => viewModel.handlePesquisaSatisfacaoItemOpenState(null, false)}
        onSubmit={viewModel.handlePesquisaSatisfacaoItemSubmit}
      />

      <DeleteDialog
        open={viewModel.itemPesquisaSatisfacaoDeleteModal}
        saving={viewModel.saving}
        title="Você realmente deseja excluir este item?"
        onClose={() => viewModel.handlePesquisaSatisfacaoItemDelete(null, false)}
        onDelete={() => viewModel.handlePesquisaSatisfacaoItemDeleteSubmit()}
      />
    </>
  );
}